import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { OfertaDtoOut } from '../models/OfertaDtoOut.model';
import { OfertaDtoIn } from '../models/OfertaDtoIn.model';
import { CompararResponse } from '../models/Comparar.model';
import { ComparadoresEnum } from '../../../core/enums/comparadores.20td.enum';

@Injectable({ providedIn: 'root' })
export class OfertasService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/ofertas`;

  getMisOfertas(): Observable<OfertaDtoOut[]> {
    return this.http.get<OfertaDtoOut[]>(this.baseUrl, { withCredentials: true });
  }

  getOfertaById(id: number): Observable<OfertaDtoOut> {
    return this.http.get<OfertaDtoOut>(`${this.baseUrl}/${id}`);
  }

  createOferta(payload: OfertaDtoIn): Observable<OfertaDtoOut> {
    return this.http.post<OfertaDtoOut>(this.baseUrl, payload);
  }

  updateOferta(id: number, payload: OfertaDtoIn): Observable<OfertaDtoOut> {
    return this.http.put<OfertaDtoOut>(`${this.baseUrl}/${id}`, payload);
  }

  deleteOfertaById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  compararOferta(id: number): Observable<CompararResponse> {
    return this.http.post<CompararResponse>(`${this.baseUrl}/${id}/comparar`, {
      proveedores: [],
    });
  }

  descargarPdf(ofertaId: number, comparador: ComparadoresEnum) {
    return this.http.get(`${this.baseUrl}/${ofertaId}/comparar/pdf?comparador=${comparador}`, {
      responseType: 'blob',
    });
  }
}
